<confect-checkbox
  [title]="specItem.display"
  [value]="value"
  (valueChange)="valueChange.emit($event)"
  [icon]="specItem.icon"
/>
